export interface BlogPost {
  slug: string;
  title: string;
  titleId: string;
  date: string;
  excerpt: string;
  excerptId: string;
  content: string;
  contentId: string;
  author: string;
  category: string;
  tags: string[];
  image?: string;
  lang: 'en' | 'zh-TW';
}

export const staticBlogPosts: BlogPost[] = [
  {
    slug: 'kyc-v7-ev-features-2026',
    title: 'KYC V7-EV: The Future of Electric Mobility',
    titleId: 'KYC V7-EV：電動出行的未來',
    date: '2026-03-01',
    excerpt: 'Discover the innovative features and technology that make KYC V7-EV the perfect choice for urban mobility.',
    excerptId: '探索讓 KYC V7-EV 成為城市出行完美選擇的創新功能和技術。',
    author: 'KYC Team',
    category: 'Technology',
    tags: ['electric-vehicle', 'innovation', 'technology', 'urban-mobility'],
    lang: 'en',
    content: 'The KYC V7-EV represents the future of electric mobility with its advanced drive-by-wire technology.',
    contentId: 'KYC V7-EV 憑藉其先進的線控技術代表了電動出行的未來。',
  },
  {
    slug: 'choosing-right-electric-vehicle',
    title: 'How to Choose the Right Electric Vehicle',
    titleId: '如何選擇合適的電動車',
    date: '2026-02-28',
    excerpt: 'A comprehensive guide to selecting the perfect electric vehicle for your business needs.',
    excerptId: '為您的業務需求選擇完美電動車的綜合指南。',
    author: 'KYC Team',
    category: 'Buying Guide',
    tags: ['electric-vehicle', 'buying-guide', 'business'],
    lang: 'en',
    content: 'Choosing the right electric vehicle is an important decision for your business.',
    contentId: '為您的業務選擇合適的電動車是一個重要決定。',
  },
  {
    slug: 'ev-maintenance-tips',
    title: 'Essential Maintenance Tips for Electric Vehicles',
    titleId: '電動車必備保養技巧',
    date: '2026-02-25',
    excerpt: 'Keep your electric vehicle running smoothly with these essential maintenance tips.',
    excerptId: '通過這些必備保養技巧讓您的電動車保持最佳狀態。',
    author: 'KYC Team',
    category: 'Maintenance',
    tags: ['maintenance', 'tips', 'electric-vehicle'],
    lang: 'en',
    content: 'Proper maintenance is crucial for keeping your electric vehicle in top condition.',
    contentId: '適當的保養對於保持電動車的最佳狀態至關重要。',
  },
];

export function getPostBySlug(slug: string): BlogPost | undefined {
  return staticBlogPosts.find((post) => post.slug === slug);
}

export function getAllPosts(): BlogPost[] {
  return staticBlogPosts;
}
